import * as types from "../constants/actionConstants";
import * as portalShared from "../portal/shared/metadataConstantsAndUtilities";

const initialState = {};

function categoryTemplateReducer(state = initialState, action) {
    let tempCategoryTemplate;
    let newState;
    switch (action.type) {
        case types.CATEGORY_TEMPLATE_GET_SUCCESS:
        case types.CATEGORY_TEMPLATE_CREATE_SUCCESS:
        case types.CATEGORY_TEMPLATE_UPDATE_SUCCESS:
            return {
                ...state,
                [action.categoryTemplate.templateKey]: {
                    ...action.categoryTemplate
                }
            };

        case types.CATEGORY_GRAPH_GET_SUCCESS:
        case types.CATEGORY_GRAPH_CREATE_SUCCESS:
        case types.CATEGORY_GRAPH_UPDATE_SUCCESS:
            return {
                ...state,
                [action.categoryTemplate.templateKey]: {
                    ...action.categoryTemplate
                }
            };


        case types.CATEGORY_TEMPLATE_ADD_GROUP_KEY:

            newState = portalShared.cloneObj(state);

            tempCategoryTemplate = newState[action.categoryTemplate.templateKey];

            if (!tempCategoryTemplate.groupKeys.includes(action.groupKey)) {
                tempCategoryTemplate.groupKeys.push(action.groupKey);
            }

            return newState;

        // case types.CATEGORY_TEMPLATE_REMOVE_GROUP_KEY:
        //     debugger;
        //     return state;

        case types.CATEGORY_TEMPLATE_ADD_SHOW_GROUP_KEYS:

            newState = portalShared.cloneObj(state);

            tempCategoryTemplate = newState[action.categoryTemplate.templateKey];

            for (let i = 0; i < action.showGroupKeys.length; i++) {

                if (!tempCategoryTemplate.showGroupKeys.includes(action.showGroupKeys[i])) {
                    tempCategoryTemplate.showGroupKeys.push(action.showGroupKeys[i]);
                }

            }

            return newState;

        case types.CATEGORY_TEMPLATE_SET_SHOW_GROUP_KEYS:
            newState = portalShared.cloneObj(state);

            tempCategoryTemplate = newState[action.categoryTemplate.templateKey];

            tempCategoryTemplate.groupKeys = tempCategoryTemplate.groupKeys.filter(key => key !== action.removedGroupKey);

            tempCategoryTemplate.showGroupKeys = action.showGroupKeys;

            return newState;

        default:
            return state;
    }
}

export default categoryTemplateReducer;
